module.exports = __webpack_public_path__ + "static/img/logo.4cb82b24.png";